import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, DataTable, Pill } from "../components/Table";

const SRC = {
  "provision": "#0091e6", "add-device": "#0091e6", "bulk-import": "#5AC8FA",
  "activate": "#34C759", "bulk-activate": "#34C759",
};

export default function ActivationLog() {
  const [logs, setLogs] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/activation-logs?limit=300").then((r) => setLogs(r.data.logs)).catch(() => {}); }, []);

  const filtered = logs.filter((l) => !q ||
    [l.imei, l.vehicle_number, l.actor_email, l.customer_name].some((v) => String(v || "").toLowerCase().includes(q.toLowerCase())));

  const cols = [
    { key: "created_at", header: "When", render: (r) => <span className="font-mono text-xs">{new Date(r.created_at).toLocaleString()}</span> },
    { key: "vehicle_number", header: "Vehicle", render: (r) => <span className="font-semibold">{r.vehicle_number}</span> },
    { key: "imei", header: "IMEI", render: (r) => <span className="font-mono text-xs">{r.imei}</span> },
    { key: "customer_name", header: "Customer", render: (r) => r.customer_name || "—" },
    { key: "actor_email", header: "Activated By", render: (r) => <div><div className="text-xs">{r.actor_email}</div><div className="text-[10px] text-muted-foreground uppercase">{r.actor_role}</div></div> },
    { key: "source", header: "Via", render: (r) => <Pill color={SRC[r.source] || "#8E8E93"}>{r.source}</Pill> },
  ];

  return (
    <div className="p-5 space-y-4">
      <PageHeader title="Activation Log" subtitle={`${logs.length} device activations · who, what and when`}
        actions={<input data-testid="log-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search vehicle / IMEI / user"
          className="bg-card border border-border rounded-sm px-3 py-1.5 text-sm w-72 focus:ring-1 focus:ring-primary focus:outline-none" />} />
      <DataTable testid="activation-log-table" columns={cols} rows={filtered} empty="No activations yet — activate a device to see the audit trail" />
    </div>
  );
}
